<template>
  <div class="page_content">

    <div class="top-title">
      Terms of Service
    </div>
    <div class="card" style="overflow: auto; height: 400px; background: #fafafa;">
      <div class="card-body">
        <div class="inner-section">


<p class=MsoNormal style='margin-bottom:12.0pt'><span style='font-size:10.0pt;
font-family:"Arial",sans-serif'>&nbsp;</span></p>

</div>

<span style='font-size:10.0pt;font-family:"Arial",sans-serif'><br clear=all
style='page-break-before:always'>
</span>

<div class=WordSection2>

<p class=MsoHeader align=center style='margin-bottom:6.0pt;text-align:center'><b><span
style='font-size:10.0pt;font-family:"Arial",sans-serif;text-transform:uppercase'>TERMS
AND CONDITIONS of PRAGYA services</span></b></p>

<p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify;text-indent:
.5in'><span style='font-size:10.0pt;font-family:"Arial",sans-serif'>This
Agreement (i.e., these Terms and Conditions and the Order Form(s) into which
these Terms and Conditions are incorporated) </span><span style='font-size:
10.0pt;font-family:"Arial",sans-serif'>is made and entered into as of the Effective
Date.  In consideration of the mutual promises contained herein, the parties
hereby agree to the following: </span></p>

</div>

<b><span style='font-size:10.0pt;font-family:"Arial",sans-serif;text-transform:
uppercase'><br clear=all style='page-break-before:auto'>
</span></b>

<div class=WordSection3>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span style='text-transform:uppercase'>Definitions</span></b>. 
Capitalized terms shall have the meanings set forth in this section, or in the
section where they are first used.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.1<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b>“<u>Access Protocols</u>”
means the passwords, access codes, technical specifications, connectivity
standards or protocols, or other relevant procedures, as may be necessary to
allow Subscriber to access the Services.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.2<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b>“<u>Authorized User</u>”<b>
</b>means any individual who is an employee or contractor of Subscriber and is
authorized by Subscriber to access the Services pursuant to Subscriber’s rights
under this Agreement.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.3<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b>“<u>Confidential
Information</u>” means all proprietary or confidential information relating to a
Disclosing Party that is disclosed or otherwise supplied in confidence to the Receiving
Party under this Agreement.  Confidential Information does not include any aggregated
data or De-Identified Data covered by Section 8.4, or any other information
that the Receiving Party can establish:  (a)&nbsp;was known to the Receiving Party
prior to receiving the same from the Disclosing Party, free of any restrictions;
(b) is independently developed by the Receiving Party without reference to the Disclosing
Party’s Confidential Information; (c)&nbsp;is acquired by the Receiving Party from
another source without restriction as to use or disclosure; or (d)&nbsp;is or
becomes part of the public domain through no fault or action of the Receiving Party.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.4<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b>“<u>Confidential Student
Information</u>” means information that personally identifies a student who is
enrolled or was previously enrolled at the Subscriber’s institution.  This term
includes the student’s name, the name of the student’s parents or family
members, the student’s (or student’s family’s) address, telephone number, email
address, date of birth, place of birth, mother’s maiden name, grades, financial
information, social security number (or other governmental identification
number), biometric information, and other information that alone or in combination
would reasonably allow a person or entity to identify the student with reasonable
certainty. Confidential Student Information does not include any information
regarding persons who do not enroll at the Subscriber’s institution.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.5<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b>“<u>De-Identified Data</u>”
means any data, including data derived from Confidential Information (and Confidential
Student Information) that has had all direct and indirect personal identifiers
removed.  This includes the removal of any names, identification numbers, and
dates of birth, address, email address, and telephone number.  De-Identified Data
does not include any data that alone or in combination would reasonably allow a
person or entity to identify a student with reasonable certainty.   </p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.6<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><u>“Directory
Information</u>” means the following Confidential Student Information:  student’s
name, the name of the student’s parents or family members, the student’s (and
student family’s) address, telephone number, email address, gender pronoun, course
of study, degree(s) awarded, completion date, expected completion date, photographs,
and any other information that is considered directory information under the
Subscriber’s “Directory Information Policy.” </p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.7<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b>“<u>Documentation</u>”
means the technical materials provided by Pragya to Subscriber in hard copy or
electronic form describing the use and operation of the Services.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.8<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b>“<u>Error</u>” means a
reproducible failure of the Services (i.e., and not of a user) to substantially
conform to the Documentation.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.9<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b>“<u>Error Corrections</u>”
means bug fixes or workarounds intended to correct Errors in the Services.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.10<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b>“<u>Order Form</u>”<b> </b>means an order form that is signed by both
parties and references these Terms and Conditions.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.11<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b>“<u>Services</u>” means the services ordered by Subscriber through
an Order Form.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.12<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b>“<u>Subscriber Content</u>” means any content and information
submitted via or in connection with the Service by on behalf of Subscriber, an
Authorized User or any other end user of the Services.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>1.13<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b>“<u>Supported Environment</u>” means the minimum hardware, software,
and connectivity configuration specified from time to time by Pragya as required
for use of the Services.  The current requirements (if any) are described in
the Order Form.</p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b>PROVISION OF SERVICES</b></p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>2.1<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Access.</b>  Subject
to Subscriber’s payment of the Fees and compliance with the terms of this
Agreement, Pragya will provide Subscriber with access to the Services. Promptly
following the Effective Date, Pragya shall provide to Subscriber the necessary
passwords, security protocols and policies and network links or connections and
Access Protocols to allow Subscriber and its Authorized Users to access the Services
in accordance with the Access Protocols.  Subscriber shall be responsible for ensuring
that users accessing the Services through single sign on are Authorized Users
and that information provided to Pragya regarding such users is accurate.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>2.2<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Support Services</b>.
Pragya will provide Subscriber with the support services described at below
<a href="#SLA">Service Level Agreement</a>.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>2.3<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b><span
style='color:black'>Hosting. </span></b>Pragya <span style='color:black'>shall,
at its own expense, provide for the hosting of the Services, provided that nothing
herein shall be construed to require </span>Pragya <span style='color:black'>to
provide for, or bear any responsibility with respect to any telecommunications
or computer network hardware required by Subscriber, any Authorized User or any
other user to provide access from the Internet to the Services.</span></p>

<p class=Legal2L2 style='margin-left:0in'><b>2.4<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b><b>No Third-Party Servicer Status.</b>  The Subscriber understands
and agrees that this Agreement does not purport to render Pragya a Third Party
Servicer as that term is defined at 34 C.F.R. §§ 668.2, 668.25 and Pragya shall
not undertake any work pursuant to this Agreement inconsistent with this
Section 2.4.  Subscriber further agrees that it shall not report Pragya as a
Third Party Servicer to the U.S. Department of Education or any other
governmental agency or accrediting body. </p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b>INTELLECTUAL PROPERTY</b></p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>3.1<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>License Grant.</b> 
Subject to the terms and conditions of this Agreement, Pragya grants to
Subscriber a non-exclusive, non-sublicensable, non-transferable license during
the Term, solely for Subscriber’s internal business purposes and in accordance with
the limitations (if any) set forth in the Order Form, (a) to access and use the
Services in accordance with the Documentation; and (b) to use and reproduce a reasonable
number of copies of the Documentation solely to support Subscriber’s use of the
Services.  </p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>3.2<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Restrictions.</b> 
Subscriber agrees that it will not, nor will Subscriber cause or permit any
Authorized User or other party to, (a) allow any third party to access the <span
style='color:black'>Services</span> or Documentation, except as expressly allowed
herein; (b) modify, adapt, alter or translate the <span style='color:black'>Services</span>
or Documentation; (c) sublicense, lease, rent, loan, distribute, transfer or
otherwise allow the use of the <span style='color:black'>Services</span> or
Documentation for the benefit of any third party; (d) reverse engineer, decompile,
disassemble, or otherwise derive or determine or attempt to derive or determine
the source code (or the underlying ideas, algorithms, structure or
organization) of the Services, except as permitted by law; or (e) create
derivative works based on the <span style='color:black'>Services</span> or Documentation.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>3.3<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Ownership.</b>  Except
for the licenses granted by Pragya under this Agreement, Pragya owns all right,
title and interest (including, but not limited to, all copyright, patent, trademark
and trade secret rights) in and to the Services and Documentation.  </p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>3.4<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Open Source
Software.  </b>Certain items of software used in the Services are subject to
“open source” or “free software” licenses (<b>“Open Source Software”</b>). 
Some of the Open Source Software is owned by third parties.  The Open Source Software
is not subject to the terms and conditions of Sections 3.1, 3.2 or 10. 
Instead, each item of Open Source Software is licensed under the terms of the
end-user license that accompanies such Open Source Software.  Nothing in this
Agreement limits Subscriber’s rights under, or grants Subscriber rights that
supersede, the terms and conditions of any applicable end user license for the
Open Source Software. If required by any license for particular Open Source
Software, Pragya makes such Open Source Software, and Pragya modifications to
that Open Source Software, available by written request at the notice address
specified on the Order Form.  </p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span style='text-transform:uppercase'>Fees.</span></b><span
style='text-transform:uppercase'>  </span>Subscriber shall pay Pragya the fees
set forth in the Order Form (the “<u>Fees</u>”). Pragya shall invoice Subscriber
for such Fees on the schedule set forth on the Order Form and the amounts set
forth in such invoices shall be due from Subscriber within fifteen (15) days’
of receipt.  Pragya may change the amount of the Fees for any upcoming Renewal
Term, provided that Pragya provides Subscriber with written notice of such change
at least sixty (60) days prior to the first day of such Renewal Term.  Non-payment
or late payment of undisputed fees is a material breach of this Agreement.  Subscriber
shall pay interest on any overdue balance at the rate of 1 ½% per month or the
maximum permitted by law, whichever is less, plus all expenses of collection.
All taxes and other governmental charges (except for income taxes), if any,
imposed on Subscriber payments hereunder shall be deemed to be in addition to
the Fees charged, and borne solely by Subscriber.  </p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>5.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span style='text-transform:uppercase'>Subscriber Content
and Responsibilities</span></b></p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>5.1<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>License; Ownership.</b> 
Subscriber hereby grants Pragya a non-exclusive, worldwide, royalty-free, fully-paid
and transferable license (a) to use the Subscriber Content as necessary for
purposes of providing the Services; and (b) to use Subscriber’s trademarks,
service marks, and logos as required to provide the Services.  As between the
parties, Subscriber owns all right, title and interest in the Subscriber Content.<b>
</b></p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>5.2<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Subscriber Warranty.</b> 
Subscriber represents and warrants that (a) prior to using the Services in
connection with any individual end user, Subscriber shall have obtained the
consent of such end user to contact such end user via the Services in such form
as required to comply with applicable law; (b) that its use of the Services
will comply with all applicable requirements of the Federal Trade Commission
and U.S. Department of Education; and (c) the Subscriber Content  shall not (i)
infringe any copyright, trademark, or patent right; (ii) misappropriate any
trade secret; (iii) be deceptive, libelous, obscene, pornographic or unlawful;
(iv) contain any viruses, worms or other malicious computer programming codes
intended to damage Pragya’s system or data; or (v) otherwise violate any privacy
or other right of any third party.  </p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>5.3<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Authorized User
Access. </b> Subscriber may permit any Authorized Users to access and use the
features and functions of the Services as contemplated by this Agreement.   User
IDs cannot be shared or used by more than one Authorized User at a time.  Subscriber
is solely responsible for maintaining the confidentiality of Access Protocols and
Pragya will not be liable for any activities undertaken by anyone using Subscriber’s
Access Protocols.  Subscriber will immediately notify Pragya of any
unauthorized use of its Access Protocols or any other breach of security
relating to the Services known to Subscriber.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>5.4<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Subscriber
Responsibility for Access, Content and Security.  </b>Unless otherwise specified
on the Order Form, Pragya is not obligated to back up any Subscriber Content;
the Subscriber is solely responsible for creating backup copies of any Subscriber
Content at Subscriber’s sole cost and expense.   Subscriber shall have the sole
responsibility for the accuracy, quality, integrity, legality, reliability, and
appropriateness of all Subscriber Content.  Subscriber must maintain the
Supported Environment (if any) described in the Order Form.  </p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>6.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b>WARRANTIES AND DISCLAIMERS</b></p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>6.1<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Limited Warranty.</b> 
Pragya represents and warrants to Subscriber that the Services will operate
free from material Errors during the Term.  Provided that Subscriber notifies Pragya
in writing of any breach of the foregoing warranty during the Term, Pragya shall,
as Subscriber’s sole and exclusive remedy, provide the support described at <a
href="#SLA">Service Level Agreement</a></p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>6.2<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Disclaimer.</b>  <span
style='text-transform:uppercase'>THE LIMITED WARRANTY SET FORTH IN SECTION 6.1 IS
MADE FOR THE BENEFIT OF SUBSCRIBER ONLY. EXCEPT AS EXPRESSLY PROVIDED IN SECTION
6.1, THE Documentation, AND SERVICES ARE PROVIDED “AS IS,” AND PRAGYA MAKES NO
(AND HEREBY DISCLAIMS ALL) OTHER  REPRESENTATIONS AND WARRANTIES, WHETHER
WRITTEN, ORAL, EXPRESS, IMPLIED OR STATUTORY, INCLUDING, WITHOUT LIMITATION, ANY
IMPLIED WARRANTIES OF MERCHANTABILITY, TITLE, NONINFRINGEMENT, AND FITNESS FOR
A PARTICULAR PURPOSE.  PRAGYA DOES NOT WARRANT THAT ALL ERRORS CAN BE CORRECTED,
OR THAT OPERATION OF THE SERVICES SHALL BE UNINTERRUPTED OR ERROR-FREE.  SOME STATES
AND JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO SOME OF
THE ABOVE LIMITATIONS MAY NOT APPLY TO SUBSCRIBER.</span></p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>7.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b> <b><span style='text-transform:uppercase'>Limitation of
Liability.  </span></b><span style='text-transform:uppercase'>excluding each
party’s indemnification obligations set forth herein in respect of third-party
claims, (A) </span>IN NO EVENT WILL EITHER PARTY BE LIABLE FOR ANY
CONSEQUENTIAL, INCIDENTAL, SPECIAL, PUNITIVE, OR OTHER INDIRECT DAMAGES
(INCLUDING, WITHOUT LIMITATION, LOST PROFITS OR LOST DATA) ARISING OUT OF OR IN
CONNECTION WITH THIS AGREEMENT OR ITS PERFORMANCE HEREUNDER AND (B) IN NO EVENT
SHALL EITHER PARTY’S LIABILITY TO THE OTHER AS A RESULT OF ANY CLAIM ARISING
UNDER THIS AGREEMENT, REGARDLESS OF WHETHER SUCH CLAIM IS BASED ON BREACH OF
CONTRACT, TORT, STRICT LIABILITY, OR ANY OTHER THEORY OF LIABILITY, EXCEED THE AMOUNT
PAID BY SUBSCRIBER IN THE TWELVE (12) MONTHS PRIOR TO THE OCCURRENCE OF THE ACT
OR OMISSION GIVING RISE TO SUCH CLAIM. <span style='text-transform:uppercase'> SOME
STATES AND JURISDICTIONS DO NOT ALLOW FOR THE EXCLUSION OR LIMITATION OF INCIDENTAL
OR CONSEQUENTIAL DAMAGES, SO THIS LIMITATION AND EXCLUSION MAY NOT APPLY TO
SUBSCRIBER.</span></p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>8.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span style='text-transform:uppercase'>Confidentiality; PRIVACY</span></b></p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>8.1<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Confidentiality.  </b>During
the Term, each party (“<u>Disclosing Party</u>”) may provide the other party (“<u>Receiving
Party</u>”) with Confidential Information.  The Receiving Party agrees that it will
not use or disclose to any third party any Confidential Information of the
Disclosing Party, except as expressly permitted under this Agreement.  The
Receiving Party will limit access to the Disclosing Party’s Confidential Information
to Authorized Users (with respect to Subscriber as Receiving Party) or to those
employees who have a need to know such Confidential Information to perform the
Receiving Party’s obligations or exercise the Receiving Party’s rights under
this Agreement, and who have been informed of the confidential nature of such
information.  In addition, the Receiving Party will protect the Disclosing
Party’s Confidential Information from unauthorized use, access, or disclosure in
the same manner that it protects its own proprietary information of a similar nature,
but in no event with less than reasonable care.  At the Disclosing Party’s
request or upon the expiration or termination of this Agreement, the Receiving
Party will return to the Disclosing Party or destroy (or permanently erase in
the case of electronic files) all copies of the Confidential Information that
the Receiving Party does not have a continuing right to use under this Agreement,
and the Receiving Party shall provide to the Disclosing Party a written affidavit
certifying compliance with this sentence.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>8.2<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b>  <b>Privacy.  </b>Pragya
agrees that its performance of the Services may involve the disclosure of
Confidential Student Information by the Subscriber to Pragya.  Pragya agrees
that it will not use or re-disclose Confidential Student Information except in
compliance with the Family Education Rights and Privacy Act (“<u>FERPA</u>”)
(20 U.S.C. § 1232g; 34 C.F.R. Part 99) and all applicable state and federal
laws.  The Subscriber acknowledges that Pragya is a “school official” with a
legitimate educational interest in receiving Confidential Student Information
under FERPA and Pragya agrees that it will comply with the requirements of 34
C.F.R. § 99.33 regarding its use and redisclosure of Confidential Student
Information.  The Subscriber agrees and consents to Pragya’s use of Directory
Information so long as such use complies with FERPA.  The Subscriber
acknowledges that it is responsible for notifying Pragya that a student has
opted-out of the Subscriber’s “Directory Information Policy.”   </p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>8.3<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b><b>Data Security.</b> Pragya agrees that it will store and process
Confidential Information, including Confidential Student Information, in
accordance with customary industry standards.  Pragya shall implement and maintain
commercially reasonable administrative, technical and physical security measures
designed to protect Confidential Information from unauthorized access,
disclosure and use.  Pragya will conduct periodic risk assessments and
remediate identified material security vulnerabilities in a commercially reasonable
manner.  Pragya will have a written data breach response plan and will take
commercially reasonable steps to notify the Subscriber once it becomes aware of
a data breach known to involve, or likely involving, Subscriber Confidential Information.
 Pragya will cooperate with the Subscriber to comply with any applicable data breach
notification laws.  </p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>8.4<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b><b>Aggregated and De-Identified Data.</b>  Pragya may use aggregated
data and De-Identified Data for product development, research, marketing, and
other purposes.  Pragya agrees that it shall not attempt to re-identify any aggregated
data or De-Identified Data unless such re-identification complies with the terms
of this Agreement.  Pragya further agrees that it shall not transfer De-Identified
Data or aggregated data to any other party unless that party agrees not to attempt
re-identification; provided, however, that Pragya may transfer De-Identified
Data or aggregated data to its successor pursuant to a merger, consolidation or
sale of substantially all of its assets pursuant to Section 11 of this Agreement
and its successor may re-identify data to the same extent that Pragya may do so
pursuant to this Agreement.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>8.5<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b><b>Confidential Student Information Return and Destruction.</b>  Upon
termination or expiration of this Agreement or thereafter, at the Subscriber’s
written request, Pragya shall, in a reasonable period of time, return all
Confidential Student Information to Subscriber or shall destroy such Confidential
Student Information that Pragya knows it possesses to the extent that destruction
is reasonably practicable.  Pragya shall not be required to return or destroy
Directory Information it has received or obtained.  Pragya shall not be
required to return or destroy aggregated data or De-Identified Data. 
Subscriber acknowledges that some data may remain in archive or other files following
Pragya’s commercially reasonable attempt to return or destroy Confidential Student
Information.  </p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>9.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b>INDEMNIFICATION</b></p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>9.1<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>By Pragya.  </b>Pragya
shall indemnify, defend and hold harmless Subscriber against any third-party claims
that the use of the Services as permitted hereunder infringes any copyright, US
patent or other intellectual property right of a third party, and Pragya shall pay
any losses, damages, costs, liabilities and expenses (including, but not limited
to, reasonable attorneys’ fees) finally awarded by a court to such third party
or otherwise agreed to in settlement of such claim by Pragya.  If any portion
of the Services becomes, or in Pragya opinion is likely to become, the subject
of a claim of infringement, Pragya may, at Pragya’s option, and as Subscriber’s
sole and exclusive remedy therefor: (a) procure for Subscriber the right to
continue using the Services; (b) replace the Services with non-infringing
software or services which do not materially impair the functionality of the
Services; (c) modify the Services so that the Services become non-infringing;
or (d) terminate this Agreement and refund any fees paid by Subscriber to Pragya
for the remainder of the term then in effect, and upon such termination, Subscriber
will immediately cease all use of the <span style='color:black'>Documentation
and Services</span>.  Notwithstanding the foregoing, Pragya shall have no
obligation under this Section 9.1 or otherwise with respect to any third-party claim
based upon (i) any use of the Services not in accordance with this Agreement or
as specified in the Documentation; (ii) any use of the Services in combination
with other products, equipment, software or data not supplied by Pragya; or (iii)
any modification of the Services by any person other than Pragya or its authorized
agents.  This Section 9.1 states the sole and exclusive remedy of Subscriber
and the entire liability of Pragya, and any of the officers, directors, employees,
shareholders, contractors or representatives of Pragya, for claims and actions
described in this Section 9.1.</p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>9.2<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>By Subscriber.</b>  Subscriber
shall indemnify defend and hold harmless Pragya against any third-party claims
arising out of (a) any failure by Subscriber or any Authorized User to comply with
applicable laws, rules and regulations (including those promulgated by the Federal
Trade Commission, the Federal Communications Commission, and the U.S.
Department of Education) in connection with its activities hereunder, including
without limitation its provision and Pragya’s authorized use of Subscriber
Content (possibly including student information) hereunder or failure to obtain
required consent from end users, (b) Subscriber’s unauthorized use of Services
hereunder and/or (c) Subscriber’s breach or alleged breach of any of its covenants,
representations or warranties hereunder, and Subscriber shall pay any losses,
damages, costs, liabilities and expenses (including, but not limited to, reasonable
attorneys’ fees) finally awarded by a court to such third party or otherwise
agreed to in settlement of such claim by Subscriber.  This Section 9.2 states
the sole and exclusive remedy of Pragya and the entire liability of Subscriber,
and any of the officers, directors, employees, shareholders, contractors or representatives
of Subscriber, for the claims and actions described in this Section 9.2.  </p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>9.3<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></b><b>Procedure.</b>  The
indemnifying party’s obligations as set forth above are expressly conditioned
upon each of the foregoing: (a) the indemnified party shall promptly notify the
indemnifying party in writing of any threatened or actual claim or suit,
provided, however, that failure to give prompt notice will not relieve the
indemnifying party of any liability hereunder (except to the extent the
indemnifying party has suffered actual material prejudice by such failure); (b)
the indemnifying party shall have sole control of the defense or settlement of
any claim or suit; and (c) the indemnified party shall (at the indemnifying
party’s expense) reasonably cooperate with the indemnifying party to facilitate
the settlement or defense of any claim or suit.  </p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>10.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span></b><b><span style='text-transform:uppercase'>Term And
Termination</span></b></p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>10.1<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b><b>Term.</b>  This Agreement commences on the Effective Date and
shall continue for the period of time specified in the Order Form (the “<u>Initial
Term</u>”) unless earlier terminated under Section 10.2.  <span
style='letter-spacing:-.15pt'>This Agreement shall automatically renew for successive
one (1) year terms (each a “<u>Renewal Term</u>”) unless either party provides
written notice to the other of its intention not to renew at least sixty (60)
days prior to the expiration of the then-current term.  If Pragya intends to
alter any of the terms on the Order Form effective for the next Renewal Term, Pragya
must notify Subscriber of those changes at least ninety (90) days prior to
expiration of the then-current term. The Initial Term and the Renewal Terms (if
any) are, collectively, the “<u>Term</u>.”</span></p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>10.2<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b><b>Termination.  </b>Either party may terminate this Agreement immediately
upon written notice to the other party if the other party materially breaches
this Agreement and fails to cure such breach within (30) days after its receipt
of written notice of such breach.  </p>

<p class=Legal2L2 style='margin-left:0in;text-indent:0in'><b>10.3<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></b><b>Effect of Termination.  </b>Immediately upon termination of this
Agreement, (a) the licenses granted to either party shall immediately terminate;
and (b) Pragya shall cease to make available and Subscriber shall cease to use
the Services. Termination shall not relieve Subscriber’s obligation to pay all
charges accrued before the effective date of termination.  Sections 3.3, 5.4,
6, 7, 8, 9, 10.3, 11 and 12 will survive the expiration or termination of this
Agreement. </p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>11.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b>GOVERNING LAW AND VENUE</b> This Agreement and any action
related thereto will be governed and interpreted by and under the laws of the Commonwealth
of Massachusetts, without reference to conflicts of laws principles.  Both parties
expressly agree that any action relating to this Agreement shall exclusively be
brought in Boston, Massachusetts, and both parties irrevocably consent to the
jurisdiction of the state and federal courts located in Boston, Massachusetts. 
Each party expressly waives any objection that it may have based on improper
venue or forum non-conveniens to the conduct of any such suit or action in any
such court.   The United Nations Convention on Contracts for the International Sale
of Goods does not apply to this Agreement.  Subscriber shall always comply with
all international and domestic laws, ordinances, regulations, and statutes that
are applicable to its use of the Services hereunder.  </p>

<p class=Legal2L1 style='margin-left:0in;text-indent:0in'><b><span
style='text-transform:uppercase'>12.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span></b><b>MISCELLANEOUS. </b>If requested by Pragya, Subscriber agrees
to cooperate in good faith with Pragya on a press release following execution
of this Agreement and agrees to allow Pragya to list (using Subscriber’s name
and/or Subscriber’s logo, as determined by Pragya) Subscriber as a customer on Pragya
website.  The parties are independent contractors and nothing in this Agreement
shall be deemed to create the relationship of partners, joint venturers, employer-employee,
master-servant, or franchisor-franchisee between the parties.  Neither party is,
or will hold itself out to be, an agent of the other party.  Neither party is
authorized to enter into any contractual commitment on behalf of the other
party. These Terms and Conditions, together with the attached Order Form(s),
contain the entire agreement of the parties and supersedes any prior or present
understanding or communications regarding its subject matter, and may only be
amended in a writing signed by both parties.  In the event of a conflict
between the terms in the Order Form and the Agreement, the terms contained in this
Agreement shall control unless otherwise expressly stated in the Order Form. In
the event any provision of this Agreement is held by a court of law or other
governmental agency to be void or unenforceable, such provision shall be changed
and interpreted so as to best accomplish the objectives of the original provision
to the fullest extent allowed by law, and the remaining provisions shall remain
in full force and effect.  Neither party shall assign this Agreement without
the other party’s prior written consent, which shall not be unreasonably withheld.
Notwithstanding the foregoing, either party may assign this Agreement to its successor
pursuant to a merger, consolidation or sale of substantially all of its assets
related to this Agreement, provided it promptly notifies the non-assigning
party in writing of the assignment and the assignee agrees in writing to be
bound by the terms of this Agreement. This Agreement shall be binding upon and
inure to the benefit of the parties and their successors and permitted assigns. 
Neither party shall be deemed to be in breach of this Agreement for any failure
or delay in performance (other than payment of Fees due hereunder) caused by reasons
beyond its reasonable control, including, but not limited to, acts of God, war,
terrorism, strikes, failure of suppliers, fires, floods or earthquakes. The use
of the Services is subject to U.S. export control laws and may be subject to
similar regulations in other countries.   Subscriber agrees to comply with all
such laws. Any notice given under this Agreement shall be in writing and shall
be sent via overnight mail by a nationally recognized express delivery service
addressed to the address and the signatory set forth above.  There are no
third-party beneficiaries to this Agreement.  This Agreement may be executed in
counterparts, each of which shall be deemed an original and both of which shall
be taken together and deemed one instrument.</p>

</div>

<span style='font-size:10.0pt;font-family:"Arial",sans-serif'><br clear=all
style='page-break-before:auto'>
</span>

<div class=WordSection4>

<p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Arial",sans-serif'>&nbsp;</span></p>

<b><span style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:black;text-transform:uppercase'><br clear=all style='page-break-before:
always'>
</span></b>

<p class=MsoToc1 align=center style='margin-top:.25in;margin-right:0in;
margin-bottom:.25in;margin-left:0in;text-align:center;line-height:115%'><a
name=SLA></a><span style='font-size:11.0pt;line-height:115%;font-family:"Arial",sans-serif;
color:windowtext'>Service Level Agreement</span></p>

<p class=MsoToc1 style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
margin-left:0in;text-align:justify'><span style='font-family:"Arial",sans-serif;
color:windowtext'>DESCRIPTION OF SUPPORT SERVICES</span></p>

<p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Arial",sans-serif'>The following support services are provided by
Pragya Systems Corp. (“Pragya”) to subscribers (“Subscriber”) of its Cloud
Services (“Application”) during the term of this Agreement:<a
name="_Toc462664216"></a><a name="_Toc472413032"></a><a name="_Toc501264308"></a><a
name="_Toc503258908"></a><a name="_Toc525526721"></a></span></p>

<p class=MsoListParagraph style='margin-bottom:10.0pt;margin-top:0in;
text-align:justify;text-indent:-.25in;line-height:115%'><span style='font-size:
10.0pt;line-height:115%;font-family:"Arial",sans-serif'>1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b><span
style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif'>Uptime.</span></b><span
style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif'>  Pragya
will maintain the Application uptime in accordance with Section 1 of this SLA.</span></p>

<p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
line-height:115%'><span style='font-size:10.0pt;line-height:115%;font-family:
"Arial",sans-serif'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span style='font-size:10.0pt;line-height:115%;font-family:
"Arial",sans-serif'>Response.</span></b><span style='font-size:10.0pt;
line-height:115%;font-family:"Arial",sans-serif'>  Pragya will respond to
Errors in accordance with Section 2 of this SLA.</span></p>

<p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
line-height:115%'><span style='font-size:10.0pt;line-height:115%;font-family:
"Arial",sans-serif'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span style='font-size:10.0pt;line-height:115%;font-family:
"Arial",sans-serif'>Documentation.</span></b><span style='font-size:10.0pt;
line-height:115%;font-family:"Arial",sans-serif'> Pragya will provide
administrative and end user documentation or access to support knowledge base.</span></p>

<p class=MsoToc1 style='margin-top:12.0pt;margin-right:0in;margin-bottom:12.0pt;
margin-left:.25in;text-align:justify;text-indent:-.25in;line-height:115%'><span
style='font-family:"Arial",sans-serif;color:windowtext'>1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
style='font-family:"Arial",sans-serif;color:windowtext'>SERVICES AVAILABILITY GUARANTEE
</span></p>

<p class=MsoNormal style='text-align:justify'><b><span style='font-size:10.0pt;
font-family:"Arial",sans-serif'>Uptime Coverage.</span></b><span
style='font-size:10.0pt;font-family:"Arial",sans-serif'>  Subject to the terms and
conditions of this Agreement, Pragya will maintain availability for http access
by Client and third parties of the Application at least 99.5% of the time
(“Availability”).  </span></p>

<p class=MsoToc1 style='margin-top:.25in;margin-right:0in;margin-bottom:12.0pt;
margin-left:.25in;text-align:justify;text-indent:-.25in;line-height:115%'><span
style='font-family:"Arial",sans-serif;color:windowtext'>2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
style='font-family:"Arial",sans-serif;color:windowtext'>ERRORS </span></p>

<p class=MsoNormal style='text-align:justify'><b><span style='font-size:10.0pt;
font-family:"Arial",sans-serif'>Error Resolution for the Application.</span></b><span
style='font-size:10.0pt;font-family:"Arial",sans-serif'>  Pragya is required to
address and resolve Errors in a timely manner. The timeliness of the resolution
is dependent upon severity of the Error on the usability and accessibility of
the Application or the usability and quality of the produced content.  Without
limiting the foregoing, Pragya will provide the following services in connection
with such defect resolution obligations:  </span></p>

<p class=MsoListParagraph style='margin-bottom:10.0pt;margin-top:0in;
text-align:justify;text-indent:-.25in;line-height:115%'><span style='font-size:
10.0pt;line-height:115%;font-family:"Arial",sans-serif'>a)<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif'>Problem
reporting by internet electronic mail.</span></p>

<p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
line-height:115%'><span style='font-size:10.0pt;line-height:115%;font-family:
"Arial",sans-serif'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif'>Telephone
support for problem determination, verification and resolution (or instruction as
to work-around, as applicable) for administrators and end users.</span></p>

<p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
line-height:115%'><span style='font-size:10.0pt;line-height:115%;font-family:
"Arial",sans-serif'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif'>Maintenance
releases to correct previously identified errors.</span></p>

<p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
line-height:115%'><span style='font-size:10.0pt;line-height:115%;font-family:
"Arial",sans-serif'>d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif'>Diagnose
and resolve Errors.</span></p>

<p class=MsoNormal style='text-align:justify'><b><span style='font-size:10.0pt;
font-family:"Arial",sans-serif'>Certain Definitions.</span></b><span
style='font-size:10.0pt;font-family:"Arial",sans-serif'>  The following terms
will have the meanings ascribed to them below: </span></p>

<p class=MsoListParagraph style='margin-bottom:10.0pt;margin-top:0in;
text-align:justify;text-indent:-.25in;line-height:115%'><span style='font-size:
10.0pt;line-height:115%;font-family:"Arial",sans-serif'>a)<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif'>“Error”
means any of a defect or critical defect.</span></p>

<p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
line-height:115%'><span style='font-size:10.0pt;line-height:115%;font-family:
"Arial",sans-serif'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif'>A
“critical defect” is defined as the system is unavailable, or program
termination which impedes Client’s ability to meet its contractual obligations
to Client’s users.</span></p>

<p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
line-height:115%'><span style='font-size:10.0pt;line-height:115%;font-family:
"Arial",sans-serif'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif'>A
“defect” is defined as an incorrect result, error message, or program termination.
Determination of a defect will be based on a comparison of the affected
product’s or service’s performance against the applicable specifications or
requirements.</span></p>

<p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
line-height:115%'><span style='font-size:10.0pt;line-height:115%;font-family:
"Arial",sans-serif'>d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;line-height:115%;font-family:"Arial",sans-serif'> “Maintenance
Release” means a new release of the Application that contains corrections to
previously identified errors.</span></p>

<p class=MsoNormal style='text-align:justify'><b><span style='font-size:10.0pt;
font-family:"Arial",sans-serif'>Response Time.</span></b><span
style='font-size:10.0pt;font-family:"Arial",sans-serif'>  Pragya will respond
to Client within the timeframes set forth in the following table:</span></p>

<p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Arial",sans-serif'>&nbsp;</span></p>

<div align=center>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none'>
 <tr>
  <td width=213 valign=top style='width:159.6pt;border:solid windowtext 1.0pt;
  background:#D9D9D9;padding:0in 5.4pt 0in 5.4pt'>
  <p class=MsoNormal><span lang=EN style='font-size:10.0pt;border:none windowtext 1.0pt;
  padding:0in'>Event</span></p>
  </td>
  <td width=156 valign=top style='width:117.0pt;border:solid windowtext 1.0pt;
  border-left:none;background:#D9D9D9;padding:0in 5.4pt 0in 5.4pt'>
  <p class=MsoNormal><span lang=EN style='font-size:10.0pt;color:black;
  border:none windowtext 1.0pt;padding:0in'>Response Time</span></p>
  </td>
 </tr>
 <tr>
  <td width=213 valign=top style='width:159.6pt;border:solid windowtext 1.0pt;
  border-top:none;padding:0in 5.4pt 0in 5.4pt'>
  <p class=MsoNormal><span lang=EN style='font-size:10.0pt;border:none windowtext 1.0pt;
  padding:0in'>Critical Defect </span></p>
  </td>
  <td width=156 valign=top style='width:117.0pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 5.4pt 0in 5.4pt'>
  <p class=MsoNormal><span lang=EN style='font-size:10.0pt;border:none windowtext 1.0pt;
  padding:0in'>1 day</span></p>
  </td>
 </tr>
 <tr>
  <td width=213 valign=top style='width:159.6pt;border:solid windowtext 1.0pt;
  border-top:none;padding:0in 5.4pt 0in 5.4pt'>
  <p class=MsoNormal><span lang=EN style='font-size:10.0pt;border:none windowtext 1.0pt;
  padding:0in'>Defect </span></p>
  </td>
  <td width=156 valign=top style='width:117.0pt;border-top:none;border-left:
  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
  padding:0in 5.4pt 0in 5.4pt'>
  <p class=MsoNormal><span lang=EN style='font-size:10.0pt;border:none windowtext 1.0pt;
  padding:0in'>2 weeks</span></p>
  </td>
 </tr>
</table>

</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'terms-of-service',
    data: () => {
      return {
        index: 0,
        status: false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/user/components/TermsOfService.vue